export default __webpack_public_path__ + "static/media/ic-actions-view.9c28100d.svg";